export default {
  common: {
    cancel: 'Отказ',
    save: 'Запази',
    close: 'Затвори',
    back: 'Назад',
    done: 'Готово',
    reload: 'Презареди',
    loading: 'Зареждане..',
    delete: 'Изтрий',
    add: 'Добави',
    update: 'Обнови',
    ok: 'OK',
    errorPrefix: 'Грешка: {name}. {message}',
  },
  stop: {
    reason: {
      'out-of-stock': 'Свърши продуктът',
      'too-busy': 'Не успяваме',
      'quality-issue': 'Проблем с качеството',
      'wait-and-retry': 'Изчакайте, после пак',
      other: 'Друго',
    },
  },
  update: {
    newVersionHeader: 'Налична е нова версия',
    newVersionMessage: 'Да обновим ли до нова версия?',
    yesReload: 'Да, презареди',
    noIgnore: 'Не, игнорирай',
    toastMessage: 'Нова версия: v{current} → v{latest}',
    toastMessageFallback: 'Налична е нова версия',
    statusUpToDate: 'Актуална',
    statusChecking: 'Проверка…',
    statusAvailable: 'v{latest} налична',
    checkNow: 'Провери за обновления',
    appVersion: 'Версия на приложението',
  },
  auth: {
    addUser: 'Добави потребител',
    versionHeader: 'Версия',
    versionHashHeader: 'Хеш на версията',
  },
  shift: {
    startShift: 'Започни смяна',
    goToAccount: 'Към профила',
  },
  kitchen: {
    title: 'Кухня',
    table: 'Маса',
    noTable: 'Без маса',
    loadingBoard: 'Зареждане на таблото..',
    noOrders: 'Все още няма поръчки',
    collapsedOrders:
      'Няма готови | Още {n} позиция готова | Още {n} позиции готови',
    collapseOrders: 'Свий',
    tabs: {
      active: 'Активни',
      done: 'История',
      stopList: 'Стоп-лист',
    },
    stopList: {
      activeEmpty: 'Стоп-листът е празен',
      activeHeader: 'На стоп ({count})',
      allItemsHeader: 'Всички позиции',
      searchPlaceholder: 'Търси в менюто',
      noMatches: 'Няма резултати',
      pickReason: 'Причина',
      pickUntil: 'До кога',
      pickScope: 'Какво',
      scopeWholeItem: 'Цялото ястие',
      pickerHeader: 'Постави на стоп',
      commentLabel: 'Коментар (по избор)',
      commentPlaceholder: 'Подскажи на келнера',
      save: 'Постави на стоп',
      untilShift: 'До края на смяната',
      until1h: '1 час',
      until3h: '3 часа',
      untilManual: 'Докато не се махне',
      untilMinutes: 'до края {count} мин',
      untilHours: 'до края {count} ч',
      clearConfirmTitle: 'Махни от стопа?',
      clearConfirmMessage: 'Махни {name} от стоп-листа?',
      clearConfirmYes: 'Да, махни',
      noItemsForMenu: 'В това меню няма позиции за твоята роля',
      noAccessibleMenus: 'Няма достъпни менюта',
      sidebarTitle: 'На стоп',
      sidebarEmptyHeading: 'Стоп-листът е чист',
      sidebarEmptyHint: 'Чукни ястие отдясно, за да го сложиш на стоп',
    },
  },
  quickOrder: {
    title: 'Бърза поръчка',
    order: 'Поръчка',
    clear: 'Изчисти',
    sidebarPlaceholder: 'Добави позиции отляво',
  },
  order: {
    order: 'Поръчка',
    itemOnStop: 'На стоп',
    orderUnknown: 'Неизвестна поръчка',
    checkout: 'Финализиране',
    sendToWork: 'Изпрати в работа',
    batch: 'ПАРТИДА',
    draftBatch: 'ЧЕРНОВА ПАРТИДА',
    addOrderToTable: 'Добави поръчка към маса',
    cancelOrder: 'Откажи поръчка',
    assignToMe: 'Възложи на мен',
    reassignTo: 'Възложи на…',
    reassignPickHeader: 'На кого да се възложи масата',
    reassignNoStaffOnShift: 'В момента няма служители на смяна',
    items: 'няма позиции | {count} позиция | {count} позиции',
    table: 'Маса',
    tableUnknown: 'Неизвестна маса',
    total: 'Общо',
    payment: 'Плащане',
    promotions: 'Промоции',
    payCash: 'Плащане в брой',
    payCard: 'Плащане с карта',
    startBatch: 'Започни партида',
    contentPlaceholder:
      'Натисни „Започни партида“ в страничния панел, за да добавиш позиции.',
    receiptPrinted: 'Чекът се принтира...',
    finalise: 'Финализирай',
    noOrderPlaceholder: 'Все още няма поръчка',
    createOrder: 'Създай поръчка',
    addMenuItem: 'Добави позиция',
    sidebarPlaceholder: 'Добавяй позиции отдясно',
    newOrder: 'Нова поръчка',
    noItemsInCategory: 'Няма позиции в категорията',
    noMenusFound: 'Не са намерени менюта',
    added: 'Добавено',
    commentAlert: {
      header: 'Въведи коментар',
      placeholder: 'Въведи текст',
    },
    cancelConfirm: {
      header: 'Отмяна на поръчка.',
      message: 'Моля, потвърди отмяната на поръчката.',
      yes: 'Да',
      no: 'Не',
    },
    moveItems: {
      enter: 'Премести позиции',
      selectTarget: 'Избери маса',
      submit: 'Премести тук',
      submitTo: 'Премести {from} → {to}',
      cancel: 'Отказ',
      mustLeaveOne: 'Остави поне 1 позиция',
      errorNotApplied: 'Преместването не е приложено',
      errorReverted: 'Преместването е върнато',
      errorBroken: 'Преместването е счупено — позиции в двете поръчки: {ids}',
    },
  },
  transaction: {
    paid: 'Платено',
    reversed: 'Сторнирано',
    type: 'Тип',
    total: 'Общо',
    items: 'Позиции',
    label: 'Транзакция №{number}',
    reverse: 'Сторнирай',
    printFiscal: 'Принтирай фискален бон',
    printPreCheck: 'Принтирай пре-бон',
    loading: 'Зареждане на транзакции..',
    newTransaction: 'Нова транзакция',
    creating: 'Създаване на транзакция..',
    addCash: 'В брой',
    addCard: 'С карта',
    finalise: 'Финализирай',
    printerNotConfigured: 'Принтерът не е настроен или свързан',
    printerError: 'Грешка от принтера: {response}',
    confirmPrint: {
      header: 'Да отпечатам ли фискален бон?',
      message:
        'Моля, потвърди отпечатването на фискалния бон. Действието е необратимо.',
      print: 'Принтирай',
    },
  },
  promotions: {
    sidebarTitle: 'Приложени промоции',
    contentTitle: 'Добави промоция',
    sidebarPlaceholder: 'Добавяй промоции отдясно',
    remove: 'Премахни',
    done: 'Готово',
    searchInputPlaceholder: 'Започни да въвеждаш',
    searchCancel: 'Отказ',
    searchPlaceholder: 'Започни да въвеждаш и тук ще се покажат резултати.',
    matchingPromotions: 'Подходящи промоции',
    apply: 'Приложи',
    applied: 'Приложена',
    scanVoucher: 'Сканирай ваучер',
    noSuggestions: 'Няма предложени промоции',
    noItemsFound: 'Не са намерени позиции.',
    searchResults: 'Резултати от търсенето',
  },
  inHouse: {
    title: 'В заведението',
    filterMap: 'Карта',
    filterStatus: 'Статус',
    filterWaiter: 'Сервитьор',
    mapMove: 'Премести',
    mapMoveCancel: 'Отказ',
    mapMoveSelectTable: 'Избери маса, на която да преместиш',
    mapMoveTitle: 'Премести поръчка от маса {from} на {to}',
    tables: 'няма маси | {count} маса | {count} маси',
    noMapCreated: 'Картата не е създадена',
    statusWaitingTitle: 'Чакащи',
    statusInProgressTitle: 'В процес',
    statusIdleTitle: 'Хранят се',
    statusCheckedOutTitle: 'Платили',
  },
  stock: {
    title: 'Склад',
    filterStock: 'Склад',
    filterGoods: 'Полуфабрикати',
    filterOrders: 'Поръчки',
    newOrder: 'Нова поръчка',
    noStockAvailable: 'Няма наличен склад',
    noStockOrders: 'Няма складови поръчки',
    noVendor: 'Без доставчик',
    statuses: {
      backlog: 'Бэклог',
      progress: 'В процес',
      arrived: 'Пристигна',
      complete: 'Завършено',
    },
    orderModal: {
      title: 'Складова поръчка',
      noItemsYet: 'Все още няма позиции',
      tapToAdd: 'Натисни позиция в каталога, за да я добавиш',
      tabProducts: 'Продукти',
      tabSupplies: 'Консумативи',
      searchProductsPlaceholder: 'Търсене на продукти...',
      searchSuppliesPlaceholder: 'Търсене на консумативи...',
      emptyCatalog: 'Нищо не е намерено',
      done: 'Готово',
      setAmount: 'Задай количество',
      clearItems: 'Изчисти позициите',
      deleteOrder: 'Изтрий поръчката',
    },
    createGoodsModal: {
      create: 'Създай',
    },
  },
  tasks: {
    title: 'Задачи',
    sidebarTitle: 'Днес',
    sidebarEmptyHeading: 'Няма задачи за днес',
    sidebarEmptyHint: 'Задачи, възложени на теб, ще се показват тук.',
    selectPrompt: 'Избери задача отляво.',
    noneAssigned: 'В момента нямаш активни задачи.',
    subtasksProgress: '{completed} от {total} подзадачи',
    detail: {
      status: {
        completed: 'Изпълнена',
        'in-progress': 'В процес',
        missed: 'Пропусната',
        pending: 'Чакаща',
      },
      subtasks: 'Подзадачи',
      verification: 'Потвърждение',
      reference: 'Референтни снимки',
      takePhoto: 'Направи снимка',
      addComment: 'Добави коментар',
      submitted: 'Готово',
      markAsDone: 'Отбележи като изпълнена',
      undo: 'Отмени изпълнението',
      commentPlaceholder: 'Добави коментар…',
      uploadFailed: 'Качването е неуспешно: {message}',
      unknownError: 'непозната грешка',
    },
  },
  settings: {
    title: 'Настройки',
    selectPrinter: 'Избери принтер',
    notSetUp: 'Не е настроен',
    debugPrinter: 'Тестов принтер',
    fiscal: {
      cardTitle: 'Фискални настройки',
      cardSubtitle: 'Фискални',
      description: 'Настройки за фискалния принтер.',
      selectedPrinter: 'Избран принтер',
      noPrintersFound: 'Няма намерени принтери',
      devMode: 'Дев режим',
      receiptPreview: 'Преглед на чек',
      openLog: 'Отвори лог',
      printerLog: 'Лог на принтера',
    },
    fiscalActions: {
      cardTitle: 'Фискални действия',
      cardSubtitle: 'Фискални',
      description: 'Действия с принтера.',
      printDuplicate: 'Принтирай дубликат',
      xReport: 'X отчет',
      zReport: 'Z отчет',
      periodReport: 'Отчет за период',
    },
    periodReport: {
      title: 'Отчет за период',
      description:
        'Оборот по данъчни групи и ДДС за избраните дати, отпечатан на фискалния принтер.',
      from: 'От',
      to: 'До',
      mode: 'Вид отчет',
      detailed: 'Подробен',
      brief: 'Съкратен',
      withPayments: 'Разбивка по плащания',
      print: 'Отпечатай отчет',
      hint: 'В отчета влизат само дните, приключени със Z отчет.',
    },
    station: {
      cardTitle: 'Настройки на станцията',
      cardSubtitle: 'Станция',
      description: 'Настройки на станцията.',
      waitersOrderBoard: 'Табло за сервитьори',
      menuItemUnits: 'Показвани мерни единици',
      noUnitsSelected: 'Няма избрани единици',
      preferLocalServer: 'Предпочитай локален сървър',
      resetServerPreference: 'Нулирай настройката за сървъра',
    },
    push: {
      cardTitle: 'Известия',
      cardSubtitle: 'Напомняния за възложени задачи',
      enableToggle: 'Активирай на това устройство',
      sendTest: 'Изпрати тестово',
      testDelivered: 'Доставено {sent} от {total}',
      testFailed: 'Неуспешно изпращане',
      notSupported: 'Това устройство не поддържа web push.',
    },
  },
}
